<template>
  <article class="info-section elr-container-full" v-if="accessory">
    <div class="elr-row">
      <div class="elr-col-full">
        <div class="info-section-header">
          <info-section-heading>
            {{capitalize(accessory.name)}}
          </info-section-heading>
          <p class="info-section-description">{{accessory.notes}}</p>
          <ItemButtons
            @onRemoveItem="removeItem"
            model="accessory"
            :item="accessory"
            :user="user"
          />
          <ItemNavigation
            :prev="accessory.prev"
            :next="accessory.next"
            model="accessory"
          />
        </div>
      </div>
      <div class="elr-col-full">
        <figure v-if="accessory.image"><img :src="`/pony-images/${accessory.image.image_path}`" :alt="accessory.name"></figure>
        <ul>
          <li><span class="elr-bold">Color:</span> {{accessory.color}}</li>
          <li><span class="elr-bold">Category:</span> {{accessory.category}}</li>
        </ul>
        <h3>Ponies:</h3>
        <ul class="pony-list">
          <li :key="pony.pivot.pony_id" v-for="pony in accessory.ponies">{{pony.name}}</li>
        </ul>
      </div>
    </div>
  </article>
</template>

<script>
import { mapState } from 'vuex';
import { capitalize, showPrompt } from '../../utils/helpers'
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import ItemButtons from '../../components/ItemButtons/ItemButtons';
import ItemNavigation from '../../components/ItemNavigation/ItemNavigation';

export default {
  name: 'Accessory',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    InfoSectionHeading,
    ItemButtons,
    ItemNavigation
  },
  mounted() {
    // fetch this even if the accessory getter returns a accessory
    // we need to make sure that we fetch the accessory's ponies and prev/next
    this.fetchAccessory(this.id);
  },
  computed: {
    ...mapState({
      user: state => state.currentUser.currentUser
    }),
    accessory() {
      const accessory = this.$store.getters['accessory/getById'](this.id)

      if (accessory) {
        return accessory;
      }

      return {};
    }
  },
  methods: {
    capitalize,
    hasItems(items) {
      if (items.length && items[0] !== 'no items') {
        return true;
      }

      return false;
    },
    fetchAccessory(id) {
      this.$store.dispatch('accessory/FETCH', { id });
    },
    removeItem(payload) {
      showPrompt();

      this.$store.dispatch('accessory/REMOVE', {
        id: payload.id
      });
    }
  },
  watch: {
    $route() {
      this.fetchAccessory(this.id);
    }
  }
};
</script>

